export default __webpack_public_path__ + "static/media/IF_MyCapabilities_Small.1e79387b.jpg";